import React from "react";

interface AnalysisSuggestionsProps {
  suggestions: {
    recommendations: string[];
    pros: string[];
    cons: string[];
    notes?: string[];
  };
  onSelectSuggestion: (
    type: "recommendations" | "pros" | "cons" | "notes",
    value: string
  ) => void;
  isLoading?: boolean;
  showProsCons?: boolean;
  showNotes?: boolean;
  showRecommendations?: boolean;
}

const AnalysisSuggestions: React.FC<AnalysisSuggestionsProps> = ({
  suggestions,
  onSelectSuggestion,
  isLoading = false,
  showProsCons = true,
  showNotes = false,
  showRecommendations = true,
}) => {
  const renderSuggestionChips = (
    items: string[],
    type: "recommendations" | "pros" | "cons" | "notes"
  ) => {
    if (items.length === 0) {
      return (
        <div className="text-sm text-gray-500 italic">
          No suggestions available
        </div>
      );
    }

    return (
      <div className="space-y-2">
        <div className="space-y-2">
          {items.map((item, index) => (
            <button
              key={index}
              type="button"
              onClick={() => onSelectSuggestion(type, item)}
              className="w-full text-left px-3 py-2 text-sm bg-gray-100 hover:bg-gray-200 text-gray-700 rounded-md transition-colors cursor-pointer group"
            >
              <span className="block">{item}</span>
            </button>
          ))}
        </div>
      </div>
    );
  };

  if (isLoading) {
    return (
      <div className="bg-gray-50 rounded-lg p-4 space-y-4">
        <div className="animate-pulse">
          <div className="h-4 bg-gray-200 rounded w-1/4 mb-2"></div>
          <div className="space-y-2">
            <div className="h-6 bg-gray-200 rounded w-3/4"></div>
            <div className="h-6 bg-gray-200 rounded w-1/2"></div>
            <div className="h-6 bg-gray-200 rounded w-2/3"></div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-gray-50 rounded-lg p-4 space-y-4">
      <h3 className="text-sm font-medium text-gray-900 mb-3">
        Suggestions from Previous Analyses
      </h3>

      <div className="space-y-4">
        {showRecommendations && (
          <>
            <div>
              <h4 className="text-xs font-medium text-gray-700 uppercase tracking-wide mb-2">
                Recommendations
              </h4>
              {renderSuggestionChips(
                suggestions.recommendations,
                "recommendations"
              )}
            </div>
          </>
        )}

        {showProsCons && (
          <>
            <div>
              <h4 className="text-xs font-medium text-gray-700 uppercase tracking-wide mb-2">
                Pros
              </h4>
              {renderSuggestionChips(suggestions.pros, "pros")}
            </div>

            <div>
              <h4 className="text-xs font-medium text-gray-700 uppercase tracking-wide mb-2">
                Cons
              </h4>
              {renderSuggestionChips(suggestions.cons, "cons")}
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default AnalysisSuggestions;
